import withPasswordHookForm from '../hoc/withPasswordHookForm';
import InputLine from './InputLine';

const InputLinePasswordWithHookForm = withPasswordHookForm(InputLine);

export default InputLinePasswordWithHookForm;
